import React from 'react';
import DescripcionSitio from "../modules/DescripcionSitio";
import SiderA from '../modules/SiderA';
import SliderHome from '../modules/SliderHome';
import ParallaxUno from '../modules/ParallaxUno';
import ImagenCentral from '../modules/ImagenCentral';
import { GalleryEventos } from '../modules/GalleryEventos';
import ImageModule from '../modules/ProvenzaImage';

export default function Home() {



    return (

        <div>


            <div className="me-12  d-lg-none"   >
                <DescripcionSitio></DescripcionSitio>
            </div>


            <div className='row'>
                <div className="col-12 col-sm-8" >
                    <SliderHome />
                </div>
                <div className="col-12 col-sm-4" >
                    <SiderA />
                </div>
            </div>



            <div className="w-75 mx-auto p-5" style={{ textAlign: 'center' }}>
                <h2>COOPMULMAG</h2>
                CONSTRUYENDO TEJIDO SOCIAL - APOYAMOS A LAS PERSONAS MÁS VULNERABLES QUE REQUIEREN APOYO PARA SUS EMPRENDIMIENTOS, FORTALECER SUS NEGOCIOS Y RECIBIR APOYO EMPRESARIAL Y FINANCIERO
            </div>

            
            <hr></hr>
            <ImagenCentral></ImagenCentral>

        </div>

    )

}